<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <button @click="cancel" class="close-button cursor-pointer" aria-label="close"><i class="fal fa-times"></i></button>

      <section class="modal-card-body">
        <div class="title has-text-centered">{{ modalTitle }}</div>
        <section v-if="hasQuestions" class="submit-questions">
          <div class="questions is-block mb-2" v-for="(question, index) in localQuestions" :key="question.id">
            <generic-input v-if="question.type === 'text'"
                           v-model="question.givenAnswer"
                           :ref="question"
                           :placeholder="question.label ? question.label : question.question"
                           width="100%">
            </generic-input>
            <generic-dropdown v-if="question.type === 'list'"
                              v-model="question.givenAnswer"
                              :inputName="question.question"
                              :items="question.answers"
                              :placeholder="question.label"
                              width="100%"
                              :isUp="index >= ((localQuestions.length - 1) / 2)">
            </generic-dropdown>
          </div>
        </section>
        <div v-if="errorMessage" class="help has-text-danger is-size-6 has-text-centered">{{ errorMessage }}</div>
        <div class="modal-buttons">
          <button class="button is-uppercase" @click="cancel">{{ $t('cancel') }}</button>
          <button class="button is-primary is-uppercase ml-3" @click="submitAnswers">{{ $t('submit') }}</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import GenericInput from '@/components/Controls/GenericComponents/input'
import GenericDropdown from '@/components/Controls/GenericComponents/dropdown'

import componentState from '@/mixins/component-state'

export default {
  props: ['questions'],
  components: {
    GenericInput,
    GenericDropdown
  },
  mixins: [componentState],
  data: function () {
    return {
      active: false,
      localQuestions: {},
      errorMessage: ''
    }
  },
  computed: {
    hasQuestions: function () {
      return this.localQuestions?.length > 0
    },
    modalTitle: function () {
      if (this.$isAjas) {
        return 'By collecting this pin, you are agreeing to share with the College or Sponsor the following registration details for future contact: first name, grade, email address, Academy Affiliation & who you are (e.g. delegate, visitor).'
      }

      if (this.$isIsef) {
        return 'By collecting this pin, you are agreeing to share your first name and email address with the college or company for future contact.'
      }

      if (!this.hasQuestions) {
        return this.$t('projectPage.collectPinModal.shareAnswers')
      }

      if (this.$isGirlsAndSteam) {
        return 'To collect exhibitor pins, please provide the below information. This information will be shared with exhibitors you choose to collect pins from.'
      }

      return this.$t('projectPage.collectPinModal.title')
    }
  },
  watch: {
    active: function (active) {
      active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
    }
  },
  methods: {
    showModal: function () {
      this.active = true
      this.localQuestions = JSON.parse(JSON.stringify(this.questions))
    },
    cancel: function () {
      this.$emit('modalCancel')
      this.close()
    },
    close: function () {
      this.localQuestions = {}
      this.active = false
    },
    submitAnswers: function () {
      this.errorMessage = ''
      if (!this.localQuestions) {
        this.$emit('modalSuccess')
        this.close()
        return
      }
      const userAnswers = []
      this.localQuestions.forEach((question) => {
        if (!question.givenAnswer) {
          this.errorMessage = this.$t('projectPage.collectPinModal.submissionModalError')
          return
        }
        const userAnswer = {
          questionID: question.id,
          answer: question.givenAnswer.value ? question.givenAnswer.value : question.givenAnswer
        }
        userAnswers.push(userAnswer)
      })
      const data = {
        answers: userAnswers
      }
      if (!this.errorMessage) {
        this.$store.dispatch('saveUserResourceAnswers', data).then(() => {
          this.$emit('modalSuccess')
          this.close()
        }, () => {
          this.errorMessage = this.$t('projectPage.collectPinModal.saveAnswersError')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.modal-card {
  text-align: center;
  overflow: hidden;
  .title {
    border-bottom: 1px solid #DCDCDC;
    padding: 1.3rem 0;
    font-weight: 300;
  }
  .close-button {
    font-size: 1.3rem;
    background-color: transparent;
    opacity: 0.75;
    position: absolute;
    right: 1.25rem;
    top: 0.5rem;
    border: none;
  }
  .submit-questions {
    margin-top: 1rem;
  }
  .modal-card-body {
    background-color: #F2F2F2;
    height: 100%;
    padding: 2rem 3rem;
    .select {
      width: 90%;
      select {
        display: block;
        width: 100%;
        text-overflow: ellipsis;
        height: 40px;
        font-size: 1rem;
      }
    }
    .question-inputs {
      width: 90%;
      &::placeholder {
         color: #565656;
       }
    }
  }
  .modal-buttons{
    margin: 2rem auto 0;
    width: 300px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
}
</style>
